// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************

jQuery(document).ready(function() {
    jQuery('#go-back').on('click', function() {
        window.history.go(-1);
        return false;
    });
});
// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Scroll Bar
// =====================================================================================================================

/**
 * Set CSS Scroll Bar Width
 * Sets the --scrollbar-width CSS variable equal to the scrollbar width
 *
 * @since 2.2.2
 */
function setCSSScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', (scrollbarWidth) + "px");
}

// Set scrollbar width on events
window.addEventListener('load', setCSSScrollbarWidth);
document.addEventListener('DOMContentLoaded', setCSSScrollbarWidth, false);
window.addEventListener('resize', setCSSScrollbarWidth, false);



// =====================================================================================================================
// Splide
// =====================================================================================================================

// import Splide from '@splidejs/splide';
